import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ButtonWhitePurpleSmall } from '@src/components/Button';

import css from './style.module.scss';

const NotFound = ({
	title,
	text,
	onClickReset,
	ResetButton,
	src,
	state,
	adapt,
}) => {
	return (
		<div
			className={cn(css.block, {
				[css[`block_state_${state}`]]: Boolean(state),
				[css[`block_adapt_${adapt}`]]: Boolean(state),
			})}
		>
			{src && (
				<img
					src={src}
					width={160}
					height={170}
					alt={t('Ничего не найдено')}
					className={css.img}
				/>
			)}
			<h2 className={css.heading}>{title}</h2>
			<p className={css.text}>{text}</p>
			{onClickReset && (
				<div>
					<ResetButton
						label={t('Сбросить все фильтры')}
						onClick={onClickReset}
					/>
				</div>
			)}
		</div>
	);
};

NotFound.propTypes = {
	title: PropTypes.string,
	text: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(
			PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
		),
	]),
	onClickReset: PropTypes.func,
	ResetButton: PropTypes.elementType,
	src: PropTypes.string,
	state: PropTypes.oneOf(['favour']),
	adapt: PropTypes.oneOf(['small']),
};

NotFound.defaultProps = {
	title: t('Ничего не найдено'),
	text: t(
		'Измените параметры поиска и попробуйте снова — мы ещё не всё вам показали!',
	),
	onClickReset: undefined,
	ResetButton: ButtonWhitePurpleSmall,
	src: '/img/illustrations/nothing-found.svg',
	state: undefined,
	adapt: undefined,
};

export default NotFound;
